import { forwardRef, useCallback, useImperativeHandle, useMemo, useState } from 'react';

import { iaRa } from 'lib/helpers/utility';

import ProvidersTable from '../ProvidersTable/ProvidersTable';

const AddProviderStep = forwardRef(
  (
    { onGoBack, practitioners, selectedProviders = [], onAdd, onSelectionCountChange, isInNetwork },
    ref
  ) => {
    const [selectedRows, setSelectedRows] = useState([]);

    const selectedCount = selectedRows.length;

    const handleSetSelectedRows = useCallback(
      (rows) => {
        setSelectedRows(rows);
        onSelectionCountChange?.(rows.length);
      },
      [onSelectionCountChange]
    );

    const handleAddProviders = useCallback(() => {
      if (selectedRows.length > 0) {
        const providerIds = selectedRows
          .map((row) => row.data?.id || row.id || row.value)
          .filter(Boolean);

        onAdd(providerIds);
        setSelectedRows([]);

        if (onSelectionCountChange) {
          onSelectionCountChange(0);
        }

        onGoBack?.();
      }
    }, [selectedRows, onAdd, onGoBack, onSelectionCountChange]);

    useImperativeHandle(ref, () => ({
      selectedCount,
      handleAddProviders
    }));

    // Filter out already selected and excluded providers
    const availableProviders = useMemo(() => {
      return iaRa(practitioners).filter((provider) => {
        const providerId = provider.value || provider.id;

        return !selectedProviders.includes(providerId);
      });
    }, [practitioners, selectedProviders]);

    const ROW_HEIGHT = 42;
    const HEADER_HEIGHT = 80;
    const EMPTY_STATE_HEIGHT = 280;
    const rowCount = availableProviders.length;
    const dynamicHeight =
      rowCount === 0 ? HEADER_HEIGHT + EMPTY_STATE_HEIGHT : HEADER_HEIGHT + rowCount * ROW_HEIGHT;

    return (
      <ProvidersTable
        addProvider
        providers={availableProviders}
        fieldName={isInNetwork ? 'in_network_providers' : 'out_of_network_providers'}
        setSelectedRows={handleSetSelectedRows}
        className="flex flex-col"
        style={{ height: `${dynamicHeight}px` }}
      />
    );
  }
);

AddProviderStep.displayName = 'AddProviderStep';

export default AddProviderStep;
